import React from "react";
import { observer } from "mobx-react-lite";
import { useManageFashionInspirationStore } from "../../ManageFashionInspirationStore";
import { Button, FlexColumn, OverflowText } from "designSystem/index";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import { grey } from "designSystem/styles/color";

const ExplorationPinnedImagesEmptyList = observer(() => {
	const { setOpenIframeDialog } = useManageFashionInspirationStore();

	return (
		<FlexColumn
			alignItems="center"
			gap={2}
			justifyContent="center"
		>
			<ImageNotSupportedIcon sx={{ height: 64, width: 64, color: grey[1000] }} />
			<OverflowText
				lineHeight={32}
				res="NoImagesPinned"
				semiBold
				size={24}
			/>
			<Button
				design="secondary"
				onClick={setOpenIframeDialog}
				res="OpenExploration"
				sx={{ fontWeight: 590 }}
			/>
		</FlexColumn>

	);
});

export default ExplorationPinnedImagesEmptyList;
